import { $httpCampaign } from '@/plugins/axios'
import AppService from '@/services/app.service'

const AgentService = {
    getAgentDetailsReport (agent, channel, fromDate, toDate, pagination) {
        let query = AppService.buildQuery({
            agent_id: agent,
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        }) + '&' + AppService.mapPagination(pagination)
        return $httpCampaign.get(`/rate-agent/${query}`)
    },
    getAgentReportPieChart (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        })
        return $httpCampaign.get(`/rate-agent-report-pie-chart/${query}`)
    },
    getAgentReportBarChart (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        })
        return $httpCampaign.get(`/rate-agent-report-bar-chart/${query}`)
    },
    getAgentList () {
        return $httpCampaign.get('/list-agent/')
    },
    getAgentOverviewReportTable (channel, fromDate, toDate, pagination) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        }) + '&' + AppService.mapPagination(pagination)
        return $httpCampaign.get(`/rate-agent-report-table/${query}`)
    },
    getAgentOverviewReportExcel (agent, channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            agent_id: agent,
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: 'agent'
        })
        return $httpCampaign.get(`/rate-agent-report-overview-excel/${query}`, { responseType: 'blob' }).then((data) => {
            let fileURL = window.URL.createObjectURL(new Blob([data.data]))
            let fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', 'Agent-Overview.xlsx')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
    },
    getAgentReportDetailsExcel (agent, channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            agent_id: agent,
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        })
        return $httpCampaign.get(`/rate-agent-report-details-excel/${query}`, { responseType: 'blob' }).then((data) => {
            let fileURL = window.URL.createObjectURL(new Blob([data.data]))
            let fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', 'Agent-Details.xlsx')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
    },
    getRatedChatReport () {
        return $httpCampaign.get('/rate-agent-report-pie-chart/')
    },
    getTimelineReport (agent, channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            agent_id: agent,
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        })
        return $httpCampaign.get('/rate-agent-report-bar-chart/?' + query)
    }
}
export default AgentService
